import AppCard from '@nxsys/components/AppCard';
import AppsContent from '@nxsys/components/AppsContainer/AppsContent';
import AppTableContainer from '@nxsys/components/AppTableContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { AppState } from '@nxsys/store';
import { showCurrencyByCountry } from '@nxsys/utils';
import { formatMoney } from '@nxsys/utils/number-helper';
import {
  getIrelandNmwBands,
  type IrelandNmwBand,
} from '@nxsys/constants/irelandNmw';
import { ColumnsType } from 'antd/lib/table';
import { useSelector } from 'react-redux';

const RevenueNMWRates: React.FC = () => {
  const { messages } = useTypedIntl();
  const { payrollCountry } = useSelector((state: AppState) => state.appStore);

  // Was a hard-coded copy of Ireland's 2023 rates, so this screen quoted
  // €11.30 while a draft payroll was being checked against €14.15.
  const rates = getIrelandNmwBands();

  const columns: ColumnsType<IrelandNmwBand> = [
    {
      title: messages['common.ageGroup'],
      dataIndex: 'ageGroup',
      key: 'ageGroup',
      width: 200,
    },
    {
      title: messages['common.minimumHourlyRateOfPay'],
      dataIndex: 'hourlyRateOfPay',
      key: 'hourlyRateOfPay',
      align: 'right',
      render: (value: number) =>
        formatMoney(value, showCurrencyByCountry(payrollCountry)),
    },
  ];

  return (
    <AppCard title={messages['common.nmwRates']} lineTitleColor="#FFE785">
      <AppsContent>
        <AppTableContainer
          rowKey="ageGroup"
          columns={columns}
          data={rates}
          loading={false}
          pagination={false}
          page={1}
          total={rates.length}
          pageSize={rates.length}
          scroll={{ x: 400 }}
        />
      </AppsContent>
    </AppCard>
  );
};

export default RevenueNMWRates;
